import { GridApi } from 'ag-grid-community';

export function getGridValue<TData = any>(api: GridApi): TData[] {
  if (!api) {
    return null;
  }

  const values = [];
  api.forEachNode(({ data }) => values.push(data));

  return values;
}
